import { render, staticRenderFns } from "./ShowroomList.vue?vue&type=template&id=b2e428a4&scoped=true"
import script from "./ShowroomList.vue?vue&type=script&lang=js"
export * from "./ShowroomList.vue?vue&type=script&lang=js"
import style0 from "./ShowroomList.vue?vue&type=style&index=0&id=b2e428a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e428a4",
  null
  
)

export default component.exports